import OPTIONS from './options';

/**
 * Init defaults for the select input.
 */
export default function buildConsentModeSelectProps({ onChange, ...additionalProps }) {
  return {
    name: 'consentMode',
    testId: 'consentModeSelect',
    alphabetized: false,
    options: OPTIONS,
    onChange,
    ...additionalProps,
  };
}
